import React from "react";
import classes from "./ShowCalculation.module.css";
const ShowCalculation = ({label,value}) => {
  return (
    <div className={classes.wrapper}>
      {label &&<h3>{label}</h3>}
      {value &&<p>{value}</p>}
    </div>
  );
};

export default ShowCalculation;
